import React from "react";
import { Dialog, DialogTitle, DialogContent, DialogActions, IconButton, Typography } from "@mui/material";
import CloseIcon from "@mui/icons-material/Close";

interface DtModalProps {
  open: boolean;
  onClose: () => void;
  title?: React.ReactNode;
  children: React.ReactNode;
  actions?: React.ReactNode;
  maxWidth?: "xs" | "sm" | "md" | "lg" | "xl";
  fullWidth?: boolean;
  isClosable?: boolean;
  sx?: {
    dialog?: object;
    title?: object;
    closeButton?: object;
    content?: object;
    actions?: object;
    typography?: object;
  };
}

const DtDialog: React.FC<DtModalProps> = ({
  open,
  onClose,
  title,
  children,
  actions,
  maxWidth = "sm",
  fullWidth = true,
  isClosable = true,
  sx = {},
}) => (
  <Dialog
    key={`${maxWidth}-${typeof title === "string" ? title : ""}`}
   
    open={open}
   
    onClose={(event, reason) => {
      // Only allow close if isClosable is true
      if (isClosable) {
        onClose();
      }
    }}
   
    maxWidth={maxWidth}
   
    fullWidth={fullWidth}
    sx={sx.dialog}
  
    disableEscapeKeyDown={!isClosable}
    // For MUI v5+, backdrop click is handled via onClose reason
  >
    {title && (
      <DialogTitle sx={{ m: 0, px: 1.5, pt: 1, pb: 1.5, ...sx.title }}>
        {typeof title === "string" ? (
          <Typography variant="h6" component="span" sx={sx.typography}>
            {title}
          </Typography>
        ) : (
          title
        )}
        {isClosable && (
          
          <IconButton
              aria-label="close"
              onClick={onClose}
              sx={{
                position: "absolute",
                right: 8,
                top: 8,
                color: (theme) => theme.palette.grey[500],
              ...sx.closeButton,
              }}
              size="small"
            >
              <CloseIcon />
            </IconButton>
        
        )}
      </DialogTitle>
    )}
    <DialogContent dividers sx={{ p: 1.5, ...sx.content }}>
      {children}
    </DialogContent>
    {actions && (
      <DialogActions sx={{ pt: 1, pb: 0.5, ...sx.actions }}>
        {actions}
      </DialogActions>
    )}
  </Dialog>
);

export { DtDialog };